import React, { useCallback } from 'react'
import cn from 'classnames'
import { Button, Col, Row } from 'react-bootstrap'

import { App } from '@monorepo/hooks'
import { useComponentVisible } from '@monorepo/hooks/Util/useComponentVisible'
import { ContractType } from '@monorepo/deprecated/interfaces'
import { Currency } from '@monorepo/components/common'

import style from './style.module.scss'

type ContractsSwitcherProps = {
  //
}

export const ContractsSwitcher: React.FC<ContractsSwitcherProps> = () => {
  const {
    isComponentVisible,
    componentRef,
    toggleComponentHandler,
    hideComponentHandler,
  } = useComponentVisible(false)
  const {
    currentContract,
    orderContracts,
    selectContractHandler,
  } = App.useContract()

  const selectHandler = useCallback(
    (item: ContractType) => {
      selectContractHandler(item)
      hideComponentHandler()
    },
    [hideComponentHandler, selectContractHandler]
  )

  if (!currentContract) {
    return null
  }

  return (
    <div
      ref={componentRef}
      className={cn(
        style.container,
        'currency-font-size-14 currency-switcher hbe hide-default-false hide-sticky-false hbe-right box-align-right'
      )}
    >
      <div
        onClick={toggleComponentHandler}
        className={cn(style.currencyToggle, 'hbe-toggle', {
          active: isComponentVisible,
        })}
      >
        {currentContract.balance < 0 ? 'Долг' : 'Баланс'}:
        <span className="highlighted-currency">
          <Currency value={Math.abs(currentContract.balance)} />
        </span>
      </div>
      <Row
        className={cn('d-shadow', style.currencyList, {
          [style.active]: isComponentVisible,
        })}
      >
        <Col id="alg_currency_selector">
          {orderContracts.map((item, idx) => (
            <Button
              key={idx}
              className="text-left text-monospace- text-muted-"
              variant="link"
              onClick={selectHandler.bind(null, item)}
            >
              {item.name}
              <br />
              <small>
                {item.balance < 0 ? 'Задолженность' : 'Баланс'}&nbsp;
                <Currency value={item.balance} />
              </small>
            </Button>
          ))}
        </Col>
      </Row>
    </div>
  )
}
